import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  matrix: {
    dates: [],
    linguists: [],
    cells: {},
  },
  holidayEvents: [],
  languages: [],
  linguists: [],
  matrixLoading: false,
  filters: {
    viewMode: "month",
    anchorDate: "",
    sourceLanguage: "",
    targetLanguage: "",
    resource: "",
    status: "",
    showAbsentOnly: false,
    showPresentOnly: false,
    startDate: "",
    endDate: "",
  },
  error: [],
};

const HolidayPlannerSlice = createSlice({
  name: "holidayPlanner",
  initialState,
  reducers: {
    setMatrix: (state, action) => ({
      ...state,
      matrix: action.payload,
    }),
    setMatrixLoading: (state, action) => ({
      ...state,
      matrixLoading: action.payload,
    }),
    updateMatrixCell: (state, action) => {
      const { userId, date, cell } = action.payload;
      const uid = String(userId);
      const userCells = { ...(state.matrix.cells[uid] || {}) };
      if (!cell) {
        delete userCells[date];
      } else {
        userCells[date] = cell;
      }
      return {
        ...state,
        matrix: {
          ...state.matrix,
          cells: {
            ...state.matrix.cells,
            [uid]: userCells,
          },
        },
      };
    },
    setHolidayEvents: (state, action) => ({
      ...state,
      holidayEvents: action.payload,
    }),
    setLanguages: (state, action) => ({
      ...state,
      languages: action.payload,
    }),
    setLinguists: (state, action) => ({
      ...state,
      linguists: action.payload,
    }),
    setFilters: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
    }),
    setError: (state, action) => ({
      ...state,
      error: action.payload,
    }),
  },
});

export const {
  setMatrix,
  setMatrixLoading,
  updateMatrixCell,
  setHolidayEvents,
  setLanguages,
  setLinguists,
  setFilters,
  setError,
} = HolidayPlannerSlice.actions;

export default HolidayPlannerSlice.reducer;
